// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0cbaba7d8a--wrapper--aQzKw","subtitle":"_0cbaba7d8a--subtitle--ao0l2"};